<template>
  <div class="opciones-section">
    <div class="opciones-header">
      <h4>Opciones de Selección</h4>
      <p class="text-muted">Configure las opciones disponibles para este atributo</p>
    </div>

    <!-- Lista de opciones -->
    <el-table
      :data="modelValue"
      border
      size="small"
      class="mb-3"
      max-height="250"
    >
      <el-table-column
        label="Etiqueta"
        prop="Etiqueta"
        min-width="150"
      />
      <el-table-column
        label="Clave"
        prop="Clave"
        min-width="120"
      >
        <template #default="{ row }">
          <span class="text-muted">{{ row.Clave || '(automática)' }}</span>
        </template>
      </el-table-column>
      <el-table-column
        label="Orden"
        prop="Orden"
        width="80"
        align="center"
      />
      <el-table-column
        label="Acciones"
        width="80"
        align="center"
      >
        <template #default="{ $index }">
          <el-button
            size="small"
            text
            type="danger"
            :icon="Delete"
            @click="removeOpcion($index)"
          />
        </template>
      </el-table-column>
    </el-table>

    <!-- Formulario para agregar nueva opción -->
    <el-form
      inline
      size="small"
    >
      <el-form-item label="Etiqueta">
        <el-input
          v-model="nuevaOpcion.Etiqueta"
          placeholder="Etiqueta visible"
          style="width: 180px"
          @keyup.enter="addOpcion"
        />
      </el-form-item>
      <el-form-item label="Clave">
        <el-input
          v-model="nuevaOpcion.Clave"
          placeholder="clave (opcional)"
          style="width: 150px"
          @keyup.enter="addOpcion"
        />
      </el-form-item>
      <el-form-item>
        <el-button
          type="primary"
          @click="addOpcion"
        >
          <i class="el-icon-plus"></i> Agregar
        </el-button>
      </el-form-item>
    </el-form>

    <el-alert
      v-if="!modelValue?.length"
      type="warning"
      :closable="false"
      show-icon
      class="mt-3"
    >
      <template #title>
        Debe agregar al menos una opción para atributos de tipo selección
      </template>
    </el-alert>
  </div>
</template>

<script setup>
import { ref } from 'vue';
import { ElMessage } from 'element-plus';
import { Delete } from '@element-plus/icons-vue';

const props = defineProps({
  modelValue: {
    type: Array,
    required: true,
  },
});

const emit = defineEmits(['update:modelValue']);

const nuevaOpcion = ref({ Etiqueta: '', Clave: '', Orden: 0 });

function addOpcion() {
  if (!nuevaOpcion.value.Etiqueta.trim()) {
    ElMessage.warning('La etiqueta es requerida');
    return;
  }

  const opciones = [...props.modelValue];
  const orden = opciones.length;

  opciones.push({
    Etiqueta: nuevaOpcion.value.Etiqueta.trim(),
    Clave: nuevaOpcion.value.Clave.trim() || null,
    Orden: orden,
    Activo: true,
  });

  emit('update:modelValue', opciones);
  nuevaOpcion.value = { Etiqueta: '', Clave: '', Orden: 0 };
}

function removeOpcion(index) {
  const opciones = [...props.modelValue];
  opciones.splice(index, 1);

  // Reordenar
  opciones.forEach((opcion, idx) => {
    opcion.Orden = idx;
  });

  emit('update:modelValue', opciones);
}
</script>

<style scoped>
.opciones-section {
  border: 1px solid #e4e7ed;
  border-radius: 4px;
  padding: 15px;
  background-color: #f9fafb;
}

.opciones-header h4 {
  margin: 0 0 5px 0;
  font-size: 14px;
  font-weight: 600;
}

.opciones-header .text-muted {
  font-size: 12px;
}

.text-muted {
  color: #909399;
  font-size: 14px;
}

.mb-3 {
  margin-bottom: 12px;
}

.mt-3 {
  margin-top: 12px;
}
</style>
